var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"authorization_detail_box"},[_c('p',{staticClass:"title"},[_vm._v("ForceCon-DTwin授权明细")]),_c('section',{staticClass:"authroization_detail_img_box"})])
}]

export { render, staticRenderFns }